function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.433 1.066c-1.388.14-2.752.433-3.182.678-.742.42-.85.795-.85 2.946v1.928l.598.14c.335.07 1.017.222 1.52.327 1.053.21 1.591.526 1.938 1.11.24.398.251.585.287 7.598.036 7.994.06 7.749-.765 8.579-.742.748-1.46.981-5.313 1.765-3.099.63-4.343.958-4.51 1.18-.084.117-.156.538-.156.947V29h25.126v-.748c0-1.239.49-1.052-6.21-2.478-1.077-.222-2.25-.514-2.596-.643-.754-.28-1.603-1.133-1.819-1.835-.167-.549-.203-13.663-.036-14.504.204-1.005.874-1.508 2.453-1.812a27.457 27.457 0 0 0 1.424-.315l.443-.117V4.947c-.012-2.91-.288-3.308-2.573-3.705-1.304-.222-4.415-.316-5.779-.176Z",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgRailSection = function SvgRailSection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRailSection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rail-section.6952dbdf.svg";
export { ForwardRef as ReactComponent };